import { MACHINE_ADD_LOADING, MACHINES_TYPES_LOADING, MACHINES_TYPES_UPDATE } from '../actions/machineActions';

const INITIAL_STATE = {
    machineLoading: false,
    machineTypes: [],
    machineTypesLoading: false,
};

export default (state = INITIAL_STATE, action) => {
    switch ( action.type ) {
        case MACHINE_ADD_LOADING:
            return {
                ...state,
                machineLoading: action.payload,
            };
        case MACHINES_TYPES_UPDATE:
            return {
                ...state,
                machineTypes: action.payload,
            };
        case MACHINES_TYPES_LOADING:
            return {
                ...state,
                machineTypesLoading: action.payload,
            };
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/app/machines/reducers/MachineFormReducer.js